module.exports = __webpack_public_path__ + "img/project-2.aa6e5cbe.jpg";